@if (videoType() === youtubeVideoType) {
  <youtube-player [videoId]="videoId()" class="zv-video-player__video-player" [width]="width()" [height]="height()" />
}
@if (videoType() === vimeoVideoType) {
  <iframe
    [src]="vimeoUrl"
    frameborder="0"
    [width]="width()"
    [height]="height()"
    referrerpolicy="strict-origin"
    allow="autoplay; fullscreen; picture-in-picture"
    mozallowfullscreen
    webkitallowfullscreen
    allowfullscreen
    class="zv-video-player__video-player"></iframe>
}
